import React from 'react';
import { AlertTriangle, Copy, Eye, Loader2 } from 'lucide-react';

const STATUS_LABELS = {
  in_review: 'in review',
  approved: 'approved',
  published: 'published',
};

const PublishedWarningModal = ({
  showPublishedWarningModal,
  setShowPublishedWarningModal,
  creatingNewVersion,
  handleCreateNewVersion,
  onBack,
  isSuperuser = false,
  onOpenReadOnly,
  publicationStatus
}) => {
  if (!showPublishedWarningModal) return null;

  const statusLabel = STATUS_LABELS[publicationStatus] || 'locked';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl dark:shadow-gray-900/20 max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-amber-100 rounded-full">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Locked Assessment</h2>
        </div>

        <div className="space-y-3 mb-6">
          <p className="text-gray-700">
            This assessment is {statusLabel} and locked. To make changes, create a new draft version.
          </p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <h3 className="font-medium text-blue-900 mb-2">To make changes:</h3>
            <p className="text-sm text-blue-800">
              Create a new draft version which will copy all content from this version.
              The current version is preserved unchanged so any study still using it is unaffected.
            </p>
          </div>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={() => {
              setShowPublishedWarningModal(false);
              onBack();
            }}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => {
              setShowPublishedWarningModal(false);
              handleCreateNewVersion();
            }}
            disabled={creatingNewVersion}
            className="flex-1 px-4 py-2 text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50 flex items-center justify-center"
          >
            {creatingNewVersion ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
                Creating...
              </>
            ) : (
              <>
                <Copy className="w-4 h-4 mr-2" />
                Create New Version
              </>
            )}
          </button>
        </div>

        {isSuperuser && onOpenReadOnly && (
          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
            <button
              onClick={onOpenReadOnly}
              className="w-full text-xs text-gray-500 hover:text-primary-600 dark:hover:text-primary-400 transition-colors flex items-center justify-center gap-1.5"
            >
              <Eye className="w-3.5 h-3.5" />
              Superuser: Open Read-Only
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublishedWarningModal;
